const site_url = process.env.SITE_URL || 'http://localhost:3100/';
const api_url = process.env.API_URL || 'http://localhost:3000/';
const development = {
  site_url: site_url,
  api_url: api_url,
  api_docs: `${api_url}docs`,
  shots_url: `${api_url}assets/paimages/`,
  assets_url: `${api_url}assets/`,
  images_url: `${api_url}assets/images/`,
  videos_url: `${api_url}assets/videos/`,
  background_url: `${api_url}assets/images/dipbg/`,
  carfax_url: `${api_url}assets/images/carfax/`,
  timezone: 'America/Los_Angeles',
  pageLimit: 20,
  invoiceTerms: [
    { value: '6', label: 'Due on receipt', days: 1 },
    { value: '7', label: 'Net 15', days: 15 },
    { value: '11', label: 'Net 20', days: 20 },
    { value: '8', label: 'Net 30', days: 30 },
    { value: '9', label: 'Net 60', days: 60 }
  ],
  publicVapidKey: 'BDOjIZosdAGeWjcxmMSL8_diRIDSwZoTV6QBkhBlb_quESGk8JcN2BseBNnz4s5tcjKlhjgXbnQLmRWcPOnqJuM',
  SentryEnabled: false,
  SentryConfig: {
    dsn: 'https://cfdf92b3c7324b9c4a81ad194fe571ec@o4510790343393280.ingest.us.sentry.io/4510795202232320',
    environment: 'development',
    sendDefaultPii: false
  },
  PostHogEnabled: false,
  PostHogConfig: {
    apiKey: 'phc_kyteJcJ76LJ4REwEf59U8kGHsRtJvToRWcjZ5zuoVCGX',
    host: 'https://us.i.posthog.com',
    environment: 'development'
  }
};
const stage = {
  site_url: 'https://dev-autoport.dealerimagepro.com/',
  api_url: 'https://dev-api.dealerimagepro.com/',
  api_docs: 'https://dev-api.dealerimagepro.com/docs',
  shots_url: 'https://dev-api.dealerimagepro.com/assets/paimages/',
  assets_url: 'https://dev-api.dealerimagepro.com/assets/',
  images_url: 'https://dev-api.dealerimagepro.com/assets/images/',
  videos_url: 'https://dev-api.dealerimagepro.com/assets/videos/',
  background_url: 'https://dev-api.dealerimagepro.com/assets/images/dipbg/',
  carfax_url: 'https://dev-api.dealerimagepro.com/assets/images/carfax/',
  timezone: 'America/Los_Angeles',
  pageLimit: 20,
  invoiceTerms: [
    { value: '6', label: 'Due on receipt', days: 1 },
    { value: '7', label: 'Net 15', days: 15 },
    { value: '11', label: 'Net 20', days: 20 },
    { value: '8', label: 'Net 30', days: 30 },
    { value: '9', label: 'Net 60', days: 60 }
  ],
  publicVapidKey: 'BDOjIZosdAGeWjcxmMSL8_diRIDSwZoTV6QBkhBlb_quESGk8JcN2BseBNnz4s5tcjKlhjgXbnQLmRWcPOnqJuM',
  SentryEnabled: false,
  SentryConfig: {
    dsn: 'https://cfdf92b3c7324b9c4a81ad194fe571ec@o4510790343393280.ingest.us.sentry.io/4510795202232320',
    environment: 'staging',
    sendDefaultPii: false
  },
  PostHogEnabled: false,
  PostHogConfig: {
    apiKey: 'phc_kyteJcJ76LJ4REwEf59U8kGHsRtJvToRWcjZ5zuoVCGX',
    host: 'https://us.i.posthog.com',
    environment: 'staging'
  }
};
const production = {
  site_url: 'https://autoport.dealerimagepro.com/',
  api_url: 'https://api.dealerimagepro.com/',
  api_docs: 'https://api.dealerimagepro.com/docs',
  shots_url: 'https://api.dealerimagepro.com/assets/paimages/',
  assets_url: 'https://api.dealerimagepro.com/assets/',
  images_url: 'https://api.dealerimagepro.com/assets/images/',
  videos_url: 'https://api.dealerimagepro.com/assets/videos/',
  background_url: 'https://api.dealerimagepro.com/assets/images/dipbg/',
  carfax_url: 'https://api.dealerimagepro.com/assets/images/carfax/',
  timezone: 'America/Los_Angeles',
  pageLimit: 50,
  invoiceTerms: [
    { value: '13', label: 'Due on receipt', days: 1 },
    { value: '14', label: 'Net 15', days: 15 },
    { value: '23', label: 'Net 20', days: 20 },
    { value: '15', label: 'Net 30', days: 30 },
    { value: '16', label: 'Net 60', days: 60 }
  ],
  publicVapidKey: 'BDOjIZosdAGeWjcxmMSL8_diRIDSwZoTV6QBkhBlb_quESGk8JcN2BseBNnz4s5tcjKlhjgXbnQLmRWcPOnqJuM',
  SentryEnabled: true,
  SentryConfig: {
    dsn: 'https://cfdf92b3c7324b9c4a81ad194fe571ec@o4510790343393280.ingest.us.sentry.io/4510795202232320',
    sendDefaultPii: false,
    environment: 'production'
  },
  PostHogEnabled: true,
  PostHogConfig: {
    apiKey: 'phc_kyteJcJ76LJ4REwEf59U8kGHsRtJvToRWcjZ5zuoVCGX',
    host: 'https://us.i.posthog.com',
    environment: 'production'
  }
};

let appConf = development;
if (process.env.REACT_APP_ENV === 'stage') {
  appConf = stage;
}
if (process.env.REACT_APP_ENV === 'production') {
  appConf = production;
}

export { appConf };
